import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import AdminBar from "components/Masterbar/AdminBar";
import { useParams } from "react-router-dom";
import { getAccountPermissions, selectAccountPermission, selectAccountPermissionsStatus, updateAccountPermission } from "redux/slices/accountPermissionsSlice";
import AccountPermissionForm from "components/AccountPermissions/form";

const currentAction = "EDIT";
const EditAccountPermission = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectAccountPermissionsStatus);
  const accountPermissions = useSelector(selectAccountPermission);
  useEffect(() => {
    dispatch(getAccountPermissions());
  }, [dispatch]);
  const onSubmit = async (payload) => {
    await dispatch(updateAccountPermission(payload)).then((res) => {
      if (res) {
        history.push(PATHS.admin.accountPermissions);
      }
    });
  };
  return (
    <>
      <Navbar />
      <AdminBar />
      <LightLayout doublebar loading={loading || !accountPermissions}>
        <AccountPermissionForm
          action={currentAction}
          initialValues={accountPermissions}
          onSubmit={onSubmit}
        />
      </LightLayout>
    </>
  );
};

export default EditAccountPermission;
